import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageChanger from "../Helpers/Components/Pagination"
import Handler from "../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import Select from 'react-select'

const Revenue = () => {
    const { pageNo } = useParams()
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [bookingDetails, setBookingDetails] = useState([])
    const [amount, setAmount] = useState(0)
    const [filter, setFilter] = useState({
        count: 10,
        filter: { label: "Year", value: "Year" }
    })
    const [checkDate, setCheckDate] = useState()
    const [date, setDate] = useState([new Date(new Date()?.setDate(new Date().getDate() - 1)), new Date()])
    const setPageNo = (value) => {
        navigate(`/revenue/${value}`)
    }
    const getCustomerDetails = async () => {
        setLoading(true)
        const response = await Handler({
            method: "post", url: `/admin/revenue/${pageNo}?count=${filter?.count || 10}`,
            data: {
                filter: filter?.filter?.value,
                ...(date?.length > 0 ? { from: new Date(date[0]) } : {}),
                ...(date?.length >= 1 ? { to: date?.length > 1 ? new Date(date[1]) : new Date(date[0]) } : {}),
                date: checkDate || new Date()
            }
        })
        if (response?.success) {
            setBookingDetails(response?.data?.result)
            setNext(response?.data?.next)
            setAmount(response?.data?.amount)
        } else {
            setBookingDetails([])
            setNext(false)
            setAmount(0)
        }
        setLoading(false)
    }
    useEffect(() => {
        getCustomerDetails()
    }, [pageNo, filter, checkDate, date])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Revenue</h5>
            <div className="layout-card mt-4">
                <div className="row gap-3 align-items-center">
                    <div className="col-lg-3">
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            onChange={(e) => { setPageNo(1); setFilter((prev) => ({ ...prev, filter: e })) }} value={filter?.filter} options={[{ label: "Month", value: "Month" }, { label: "Year", value: "Year" }, { label: "Customize", value: "Customize" }]} />
                    </div>
                    <div className="col-lg-3">
                        <div className=" datepicker-top">
                            {
                                filter?.filter?.value === "Customize" ?
                                    <DatePicker
                                        range
                                        onChange={(e) => { setPageNo(1); setDate(e) }}
                                        value={date}
                                    />
                                    :
                                    <DatePicker
                                        onlyYearPicker={filter?.filter?.value === "Year"}
                                        onlyMonthPicker={filter?.filter?.value === "Month"}
                                        onChange={(e) => { setPageNo(1); if(e) {setCheckDate(new Date(e))} else setCheckDate(null) }}
                                        value={checkDate || new Date()}
                                    />
                            }
                        </div>
                    </div>
                </div>
                <div className="my-3 fs-5 fw-medium">REVENUE: <i className="fa-solid fa-indian-rupee-sign"></i> {amount || 0}</div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th>Booking ID</th>
                                <th>Cust ID</th>
                                <th>Name</th>
                                <th>Car ID </th>
                                <th> Delivery Date </th>
                                <th> Pickup Date </th>
                                <th> Total Days </th>
                                <th> Refund Amount </th>
                                <th> GST </th>
                                <th> Total Cost Collected </th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (bookingDetails && bookingDetails?.length !== 0 ? bookingDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row`}>
                                            <td>{value?.bookingId || ""}</td>
                                            <td>{value?.customerId || ""}</td>
                                            <td className="text-capitalize">{(value?.name || "")}</td>
                                            <td>{value?.carId || ""}</td>
                                            <td>{value?.delivery ? moment(value?.delivery).format('DD/MM/YYYY hh:mm A') : ""}</td>
                                            <td>{value?.pickup ? moment(value?.pickup).format('DD/MM/YYYY hh:mm A') : ""}</td>
                                            <td>{value?.totalDays || 0}</td>
                                            <td>{value?.refund || 0}</td>
                                            <td>{value?.gst || 0}</td>
                                            <td>{value?.totalCostCollected || 0}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={10}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={10} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilter((prev) => ({ ...prev, count: Number(selectedoption?.value) }))
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='revenue' />
            </div>


        </React.Fragment>
    )
}

export default Revenue;